import { IconContainer } from '@/components/IconContainer'

import s from './LinkTypeSelector.module.css'

type Props = {
  title: string
  description: string
  icon: React.ReactNode
  value: string
  checked: boolean
  children?: React.ReactNode
  disabled?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const LinkTypeSelector = ({
  title,
  description,
  icon,
  value,
  checked,
  children,
  disabled,
  onChange,
}: Props) => {
  return (
    <label
      className={`${s.container} ${checked ? s.isActive : ''} ${
        disabled ? s.isDisabled : ''
      } ${children ? s.hasChildren : ''}`}
      htmlFor={`linkType-${value}`}
    >
      <div className={s.leftContent}>
        <IconContainer isHighlighted={checked}>{icon}</IconContainer>
        <div className={s.text}>
          <div className={s.title}>{title}</div>
          <p className={s.description}>{description}</p>
        </div>
      </div>
      <div className={s.rightContent}>
        {children}
        {!disabled && (
          <input
            className={s.radioInput}
            type="radio"
            id={`linkType-${value}`}
            name="type"
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
          />
        )}
      </div>
    </label>
  )
}
